export class OutpostRemoteViewModel {
  constructor() {}

  public OnInit(): void {
    // Initialize outpost remote view model
  }

  public static LastState: OutpostRemoteViewModel;
}
